import { Route } from './Route'
import { store } from '../redux/store'
import { currentUserSortedCompaniesSelector } from '../redux/session/currentUser/selectors'
import { sessionContractIdSelector, sessionLayoutSelector } from '../redux/session/contract/selectors'
import { contextCompanySelector } from '../redux/context/company/selectors'
import { vouchersConfig } from '../config/integrations/vouchers'
import { ContractFranchise } from '../types/contract/Contract'
import { Authority } from '../utils/Authorizable/types'
import { GroupSettingDataSource } from '../features/companyGroup/types/CompanyGroupSettings'

export const isValidRoute = (routes: Route[], path: string) => {
  let valid = false
  function recurse(data: Route[]) {
    for (const route of data) {
      if (route.path === path) {
        valid = true
        break
      }
      if (route.routes) {
        recurse(route.routes)
        if (valid) break
      }
    }
  }

  recurse(routes)

  return valid
}

/** Custom authorities */

// Is company a group
export const isGroupCompany = () => {
  const state: any = store.getState()
  const company = contextCompanySelector(state)
  return !!company?.groupId
}

// Non-group companies bypass the group-budget-source check entirely, since
// they can never have a groupBudgetSource value in the first place.
export const groupBudgetAuthority = (): Authority[] => [
  { custom: () => !isGroupCompany() },
  { groupBudgetSource: GroupSettingDataSource.group, custom: isGroupCompany }
]

// Is company a elimination company
export const isEliminationCompany = () => {
  const state: any = store.getState()
  const company = contextCompanySelector(state)
  return !!company?.elimination
}

// A real group company - part of a group, and not an elimination company
export const groupAuthority: Authority = { custom: () => isGroupCompany() && !isEliminationCompany() }

/** Does user have more than one company */
export const multiCompany = () => {
  const state: any = store.getState()
  const companies = currentUserSortedCompaniesSelector(state)
  return companies.length > 1
}

export const showAccountorLayout = () => {
  const state: any = store.getState()
  const layout = sessionLayoutSelector(state)
  return layout === 'accountor'
}

export const showEconiaNovaIntegration = () => {
  const state: any = store.getState()
  const contractId = sessionContractIdSelector(state)
  return contractId === 109
}

export const vouchersEnabled = () => {
  const state: any = store.getState()
  const { accountingSoftware } = contextCompanySelector(state) || {}
  return !!accountingSoftware && vouchersConfig[accountingSoftware]
}

export const showKiinteistomaailmaLayout = () => {
  const state: any = store.getState()
  const layout = sessionLayoutSelector(state)
  const companies = currentUserSortedCompaniesSelector(state)

  if (layout === 'staria') {
    return true
  }

  return companies?.some(company => company?.contract?.franchise === ContractFranchise.KIINTEISTÖMAAILMA) || false
}
